import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// Services

@Injectable()
export class HeaderService {
    private _isToggledSubject = new BehaviorSubject<boolean>(false);
    private _languageSubject = new BehaviorSubject<boolean>(false);

    isToggled = this._isToggledSubject.asObservable();

    setToggle(toggle: boolean): void {
        this._isToggledSubject.next(toggle);
    }

    setLanguage(language: string): void {
        this._languageSubject.next(language != sessionStorage.getItem('currentCulture').substr(0, 2));
    }
}
